var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 4h-15A1.5 1.5 0 0 0 4 5.5v15A1.5 1.5 0 0 0 5.5 22h15a1.5 1.5 0 0 0 1.5-1.5v-15A1.5 1.5 0 0 0 20.5 4z",
    stroke: "#FF7D0E",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7h-2.293a.5.5 0 0 0-.354.854l2.293 2.292A.5.5 0 0 0 19 9.793V7.5a.5.5 0 0 0-.5-.5zM7 7.5v2.293a.5.5 0 0 0 .854.354l2.292-2.293A.5.5 0 0 0 9.793 7H7.5a.5.5 0 0 0-.5.5zM7.5 19h2.293a.5.5 0 0 0 .354-.854l-2.293-2.293a.5.5 0 0 0-.854.354V18.5a.5.5 0 0 0 .5.5zm11.5-.5v-2.293a.5.5 0 0 0-.854-.354l-2.293 2.293a.5.5 0 0 0 .354.854H18.5a.5.5 0 0 0 .5-.5z",
    fill: "#FF7D0E"
  })));
};
export default __webpack_public_path__ + "static/media/extended-trip.94e2818d.svg";
export { SvgComponent as ReactComponent };